import type { Feedback } from '@@partner:types:app'
import type {
  CommonSort,
  NestedFilter,
  CommonPager,
  PageInfo
} from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'

export interface FetchFeedbacks {
  feedbacks: {
    edges: Feedback[]
    pageInfo: PageInfo
  }
}

export interface FetchFeedbacksVariables {
  filter?: NestedFilter
  sort?: CommonSort
  pager: CommonPager
}

export const GQL_QUERY_FETCH_FEEDBACKS = gql`
  query(
    $filter: NestedFilterInput
    $pager: CommonPagerInput
    $sort: CommonSortInput
  ) {
    feedbacks: allFeedbacks(
      filter: $filter
      sort: $sort
      pager: $pager
    ) {
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
      edges {
        id
        brand_id
        order_id
        shop {
          id
          name
          address
        }
        customer {
          id
          first_name
          last_name
          phone
        }
        review
        general_rating
        assemble_rating
        shipping_rating
        product_rating
        need_call
        manage_comment
        images {
          url
        }
        order {
          id
          fullName
          courier {
            id
          }
          assembler {
            id
          }
          shop {
            id
          }
        }
      }
    }
  }

`

export const useQueryFeedbacks = (variables?: FetchFeedbacksVariables) => {
  return useQuery<FetchFeedbacks, FetchFeedbacksVariables>(
    GQL_QUERY_FETCH_FEEDBACKS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )
}
